/**
 * Strips all HTML tags from a string.
 * @param {string} input - The string to strip HTML tags from.
 * @returns {string} The string without HTML tags.
 */
export default (input) => {
	if (typeof input !== 'string') return input;
	return input.replace(/<[^>]*>/g, '');
};
